import * as yup from 'yup';

export const loginValidations = yup.object().shape({
  usuario: yup.string().required('Usuário é obrigatório'),
  senha: yup.string().required('Senha é obrigatória')
});

export const passwordChangeValidations = yup.object().shape({
  new_password: yup.string().required('Nova senha é obrigatória'),
  password_confirm: yup
    .string()
    .oneOf([yup.ref('new_password'), null], 'As senhas devem ser iguais')
    .required('Confirmação de senha é obrigatória')
});

export const registerValidations = yup.object().shape({
  email: yup.string().email('Email inválido').required('Email é obrigatório'),
  password: yup.string().required('Senha é obrigatória'),
  password_confirmation: yup.string().oneOf([yup.ref('password'), null], 'Senhas não conferem')
});

export const UserPasswordEditSchema = yup.object().shape({
  current_password: yup.string().required('Senha Atual é obrigatória'),
  new_password: yup.string().required('Nova senha é obrigatória'),
  password_confirm: yup
    .string()
    .oneOf([yup.ref('new_password'), null], 'As senhas devem ser iguais')
    .required('Confirmação de senha é obrigatória')
});

export const PostScheme = yup.object().shape({
  post: yup.string().required('Descrição é obrigatória')
});
